<div class="dynamic-form">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="row">
        <div *ngFor="let question of questions" class="form-group" [ngClass]="colSize + question.size">
          <app-question [question]="question" [form]="form" (onEvent)="retrieveEvent($event)"></app-question>
        </div>
        <div *ngIf="inline" class="col-xs-12 col-sm-3">
          <div class="row">
            <div *ngFor="let btn of config.buttons" class="col-xs-6"  [ngClass]="colSize + btn.size">
              <label class="hidden-label" style="opacity:0;">.</label>
              <button (click)="onBtnEvent(btn.type, $event)" [class]="btn.class + ' ' + 'btn' + ' ' + 'btn-block'" [type]="btn.type"
                [disabled]="btn.type === 'submit' && !form.valid">
                {{btn.title}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!inline" class="row">
        <div class="col-sm-12 flex-wrapper-col">
          <button *ngFor="let btn of config.buttons" (click)="onBtnEvent(btn.type, $event)" [class]="btn.class + ' ' + 'btn' + ' ' + 'btn-block'" [type]="btn.type"
            [disabled]="btn.type === 'submit' && !form.valid">
            {{btn.title}}
          </button>
        </div>
      </div>
    </form>
</div>
